<template>
	<c-dialog ref="dialog" title="分润调拨详情" mode="slide" width="1000" enable-flex mask-close>
		<template #head>
			<div class="m-detail-tag flex-center-cross">
				<label class="transfer-code">{{detailData.transfer_code || '-'}}</label>
				<c-state tag dict="PROFIT_TRANSFER_STATE" :value="detailData.transfer_state"></c-state>
			</div>
		</template>

		<div class="m-detail-body">
			<c-title>单据信息</c-title>
			<div class="m-head-grid">
				<div class="head-item"><label>调拨方向</label><span>{{headDirection}}</span></div>
				<div class="head-item"><label>对方商户</label><span>{{detailData.merchant_name || '-'}}</span></div>
				<div class="head-item"><label>分润比例</label><span>{{formatRatio(detailData.transfer_ratio)}}</span></div>
				<div class="head-item"><label>调拨数量</label><span>{{detailData.total_qty || 0}}</span></div>
				<div class="head-item"><label>接收数量</label><span>{{receiveQty}}</span></div>
				<div class="head-item"><label>接收差异</label><span v-if="rejectQty">-</span><span v-else class="z-diff">{{diffQty}}</span></div>
				<div class="head-item"><label>待接收</label><span :style="pendingQty ? 'color:#faad14;' : ''">{{pendingQty}}</span></div>
				<div class="head-item"><label>驳回数量</label><span v-if="rejectQty" style="color:#f5222d;">{{rejectQty}}</span><span v-else>-</span></div>
				<div class="head-item"><label>快递单号</label><span>{{detailData.express_no || '-'}}</span></div>
				<div class="head-item"><label>创建人</label><span>{{detailData.create_user_name || '-'}}</span></div>
				<div class="head-item"><label>创建时间</label><span>{{detailData.create_date || '-'}}</span></div>
				<div class="head-item"><label>接收人</label><span>{{detailData.receive_user_name || '-'}}</span></div>
				<div class="head-item"><label>接收时间</label><span>{{detailData.receive_date || '-'}}</span></div>
				<div class="head-item"><label>备注</label><span>{{detailData.remark || '-'}}</span></div>
			</div>

			<c-title>调拨产品明细</c-title>
			<c-table ref="productTable" :data="productList" border :paging="false">
				<template #empty>
					<c-empty message="暂无产品明细"></c-empty>
				</template>
				<c-table-column label="产品信息" width="300">
					<template #default="{data}">
						<m-product-info :name="data.product_info" :level="data.level_type" :code="showCode(data)" :imei="data.produce_imei"></m-product-info>
					</template>
				</c-table-column>
				<c-table-column label="成本价" width="80">
					<template #default="{data}">{{data.cost_price ? '¥' + data.cost_price : '-'}}</template>
				</c-table-column>
				<c-table-column label="售出价" width="80">
					<template #default="{data}">{{data.sale_price ? '¥' + data.sale_price : '-'}}</template>
				</c-table-column>
				<c-table-column label="分润金额" width="80">
					<template #default="{data}"><span class="z-profit">{{data.profit_amount ? '¥' + data.profit_amount : '-'}}</span></template>
				</c-table-column>
				<c-table-column label="是否接收" width="80">
					<template #default="{data}"><span :class="receiveStateClass(data.receive_state)">{{receiveStateText(data.receive_state)}}</span></template>
				</c-table-column>
				<c-table-column label="销售状态" width="80">
					<template #default="{data}"><c-state dict="PROFIT_SALE_STATE" :value="data.sale_state"></c-state></template>
				</c-table-column>
				<c-table-column label="退货状态" width="80">
					<template #default="{data}">
						<c-state v-if="data.return_state" dict="PROFIT_LINE_RETURN_STATE" :value="data.return_state"></c-state><span v-else>-</span>
					</template>
				</c-table-column>
				<c-table-column label="是否结算" width="80">
					<template #default="{data}">{{settleText(data)}}</template>
				</c-table-column>
				<c-table-column type="button" label="操作" width="80">
					<template #default="{data}">
						<c-table-button v-if="canSettle(data) && auth('b_profit_transfer_settle')" icon="tf-check" color="main" @click="settleOne(data)">结算</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</div>

		<template #button>
			<c-button v-if="canReject" size="dialog" color="red" @click="rejectTransfer">驳回未接收</c-button>
			<c-button v-if="canRejectConfirm" size="dialog" color="main" @click="rejectConfirmTransfer">驳回确认</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">关闭</c-button>
		</template>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'profitTransferDetail',

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			receiveQty() {
				return this.productList.filter(item => item.receive_state == 1).length;
			},

			diffQty() {
				return (this.detailData.total_qty || 0) - this.receiveQty;
			},

			pendingQty() {
				return this.productList.filter(item => item.receive_state == 0).length;
			},

			rejectingQty() {
				return this.productList.filter(item => item.receive_state == 2).length;
			},

			rejectedQty() {
				return this.productList.filter(item => item.receive_state == 3).length;
			},

			rejectQty() {
				//驳回数量=驳回中+已驳回
				return this.rejectingQty + this.rejectedQty;
			},

			canReject() {
				//调入侧：存在未接收明细时可一次性全量驳回
				return this.detailData.direction == 2 && this.detailData.transfer_state == 1 && this.pendingQty > 0 && this.auth('b_profit_transfer_receive');
			},

			canRejectConfirm() {
				//调出侧：存在驳回中明细时确认回库
				return this.detailData.direction == 1 && this.detailData.transfer_state == 1 && this.rejectingQty > 0 && this.auth('b_profit_transfer_edit');
			},

			headDirection() {
				//方向由详情接口按当前商户视角返回（1我调出的，2调拨给我的）
				if (this.detailData.direction == 2) {
					return (this.detailData.merchant_name || '对方') + ' → 本商户';
				}
				return '本商户 → ' + (this.detailData.merchant_name || '对方');
			}
		},

		data() {
			return {
				transferId: '',
				detailData: {},
				productList: []
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(id) {
				this.transferId = id;
				this.detailData = {};
				this.productList = [];
				this.loadDetail();
				this.$refs.dialog.open();
			},

			/*********加载详情**********/
			loadDetail() {
				this.request({
					url: '/profitTransfer/detail',
					data: {id: this.transferId},
					loading: true,
					success: data => {
						this.detailData = data || {};
						this.productList = data.product_list || [];
					}
				});
			},

			/*********背贴码展示口径：调入侧接收后显示新码，其余显示原码**********/
			showCode(data) {
				if (this.detailData.direction == 2 && data.receive_state == 1 && data.target_produce_unique_code) {
					return data.target_produce_unique_code;
				}
				return data.produce_unique_code;
			},

			/*********分润比例展示**********/
			formatRatio(val) {
				if (val === null || val === undefined || val === '') {
					return '-';
				}
				return Number(val) + '%';
			},

			/*********接收状态四态文本（内置映射，驳回等新值不依赖字典数据）**********/
			receiveStateText(state) {
				if (state == 1) {
					return '已接收';
				}
				if (state == 2) {
					return '驳回中';
				}
				if (state == 3) {
					return '已驳回';
				}
				return '待接收';
			},

			/*********接收状态四态颜色**********/
			receiveStateClass(state) {
				if (state == 1) {
					return 'z-received';
				}
				if (state == 2) {
					return 'z-rejecting';
				}
				if (state == 3) {
					return 'z-rejected';
				}
				return 'z-pending';
			},

			/*********结算三态文本**********/
			settleText(data) {
				if (data.settle_state == 1) {
					return '已结算';
				}
				if (data.receive_state == 1 && data.sale_state == 1) {
					return '待结算';
				}
				return '未结算';
			},

			/*********是否可结算**********/
			canSettle(data) {
				return data.receive_state == 1 && data.sale_state == 1 && data.settle_state == 0 && data.return_state != 1;
			},

			/*********单笔结算**********/
			settleOne(data) {
				this.$confirm({
					message: '确认结算背贴码【' + this.showCode(data) + '】？',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/settle',
							data: {ids: [data.id]},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '结算成功', type: 'success'});
								this.loadDetail();
								this.$emit('resolve');
							},
							fail: (code, data, msg) => {
								this.$message({message: msg, type: 'error'});
								return false;
							}
						});
					}
				});
			},

			/*********驳回未接收（调入侧：一次性全量驳回）**********/
			rejectTransfer() {
				this.$confirm({
					message: '将全量驳回调拨单【' + (this.detailData.transfer_code || '') + '】全部【' + this.pendingQty + '】件未接收商品？驳回后待调拨方确认回库，不可撤销！',
					buttonName: '确定驳回',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/reject',
							data: {id: this.transferId},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '驳回成功', type: 'success'});
								this.loadDetail();
								this.$emit('resolve');
							}
						});
					}
				});
			},

			/*********驳回确认（调出侧：驳回中商品回滚在库）**********/
			rejectConfirmTransfer() {
				this.$confirm({
					message: '确认驳回调拨单【' + (this.detailData.transfer_code || '') + '】的【' + this.rejectingQty + '】件商品？确认后商品回滚在库，不可撤销！',
					buttonName: '确认',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/reject/confirm',
							data: {id: this.transferId},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '驳回确认成功', type: 'success'});
								this.loadDetail();
								this.$emit('resolve');
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 10px;

		.transfer-code {
			font-size: 13px;
			color: #666;
		}
	}

	.m-detail-body {
		padding: 0 16px;
	}

	.m-head-grid {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;

		.head-item {
			width: 33.33%;
			padding: 6px 0;
			font-size: 13px;

			label {
				color: #999;
				margin-right: 8px;
			}

			span {
				color: #333;
			}

			.z-diff {
				color: #f5222d;
			}
		}
	}

	.z-profit {
		color: #f5222d;
	}

	.z-received {
		color: #52c41a;
	}

	.z-rejecting {
		color: #faad14;
	}

	.z-rejected {
		color: #f5222d;
	}

	.z-pending {
		color: #999;
	}
</style>
